const isControlCharacter = (character: string) => {
  const code = character.charCodeAt(0);

  return code <= 0x1f || (code >= 0x7f && code <= 0x9f);
};

// Browsers ignore control characters inside a scheme, so a tab spliced into
// "javascript:" still runs. Strip them before deciding anything.
const stripControlCharacters = (value: string) =>
  Array.from(value)
    .filter((character) => !isControlCharacter(character))
    .join('');

/**
 * Whether a link destination coming from remote configuration is safe to put in
 * an anchor. Only same-origin paths and http(s) URLs are; anything else could
 * be a `javascript:` payload that runs when someone clicks the link.
 */
export const isSafeNavHref = (href: string | undefined): boolean => {
  if (!href) {
    return false;
  }

  const normalized = stripControlCharacters(href).trim().toLowerCase();

  // A protocol-relative URL borrows the current scheme and points off-site.
  if (normalized.startsWith('//')) {
    return false;
  }

  return (
    normalized.startsWith('/') ||
    normalized.startsWith('http://') ||
    normalized.startsWith('https://')
  );
};
